import { TipoCuentaEnum } from './Const/TipoCuentaEnum';
import { NivelTensionEnum } from './Const/NivelTensionEnum';

const nivelTensionKV = async (tipoCuentaId, kv, form) => {
  let nivelTensionValue = null;

  if (tipoCuentaId === TipoCuentaEnum.PROYECTOS_EXPANSION.id) {
    if (kv <= 30) {
      nivelTensionValue = NivelTensionEnum.NIVEL_2.id;
    } else {
      nivelTensionValue = NivelTensionEnum.NIVEL_3.id;
    }
  }

  if (nivelTensionValue === null) {
    return null;
  }

  form.setState((statePrev) => {
    return {
      form: {
        ...statePrev.form,
        nivelTension: {
          ...form.state.form.nivelTension,
          value: nivelTensionValue,
        },
      },
    };
  });
};

export default nivelTensionKV;
